import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import { CustEEItemParams } from './models'
import {
  CustomFieldsServerData,
  CustomFieldsGroup,
  CustomFieldsAttributes,
  CustEEItemsActions,
} from './models/customFields.types'

export class CustomFieldsProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  public get(
    groupId: CustomFieldsGroup,
    attributes: CustomFieldsAttributes,
  ): Promise<HttpServiceResponse<CustomFieldsServerData>> {
    const queryString = qs.stringify({
      groupid: groupId,
      productid: attributes.productId,
      subgroupid: attributes.subGroupId,
      clienttype: attributes.clientType,
      collateraltype: attributes.collateralType,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public custEEItems<T = any>(
    action: CustEEItemsActions,
    params: Partial<CustEEItemParams>,
  ): Promise<HttpServiceResponse<T>> {
    const url = this.customUrl('cust_ee_items_api')

    const query = qs.stringify({
      action,
      ...params,
    })

    return this.http.get(`${url}?${query}`)
  }

  private get url(): string {
    return `${this.baseUrl}/custfields_view_api.php`
  }

  private customUrl(path: string): string {
    return `${this.baseUrl}/${path}.php`
  }
}
